import { endpoints } from '../Constants';
import { authHeader, toQueryStringURL } from '../Helpers';
import handleResponse from './helpers';

const cvatServices = {
	fetchProjects,
	prepareShapeModelTrainingData,
	fetchTrainStatus,
	startShapeModelTraining,
	createTaskFromQueue,
	fetchJobs,
	updateJob,
	assignTask,
	unassignTask,
	completeTask,
	fetchTaskAssignments,
	queueSelection,
	unqueueSelection,
	registerWebhook,
};

function getHeaders() {
	return {
		...authHeader(),
		Accept: 'application/json',
		'Content-Type': 'application/json',
	};
}

function fetchProjects(req = {}) {
	const url = toQueryStringURL(endpoints.CVAT_PROJECTS, req?.params ?? {});
	const requestOptions = {
		method: 'GET',
		headers: getHeaders(),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function prepareShapeModelTrainingData(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: getHeaders(),
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(
		endpoints.SHAPE_MODEL_PREPARE_TRAINING_DATA,
		requestOptions
	).then(handleResponse);
}

function fetchTrainStatus(req = {}) {
	const url = toQueryStringURL(
		endpoints.SHAPE_MODEL_TRAIN_STATUS,
		req?.params ?? {}
	);
	const requestOptions = {
		method: 'GET',
		headers: getHeaders(),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function startShapeModelTraining(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: getHeaders(),
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(endpoints.SHAPE_MODEL_TRAIN, requestOptions).then(handleResponse);
}

function createTaskFromQueue(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: getHeaders(),
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(endpoints.CVAT_TASK_CREATE_FROM_QUEUE, requestOptions).then(
		handleResponse
	);
}

function fetchJobs(req = {}) {
	const url = toQueryStringURL(endpoints.CVAT_JOBS, req?.params ?? {});
	const requestOptions = {
		method: 'GET',
		headers: getHeaders(),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function updateJob(req = {}) {
	const requestOptions = {
		method: 'PATCH',
		headers: getHeaders(),
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(`${endpoints.CVAT_JOBS}/${req?.jobId}`, requestOptions).then(
		handleResponse
	);
}

function assignTask(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: getHeaders(),
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(endpoints.CVAT_TASK_ASSIGN, requestOptions).then(handleResponse);
}

function unassignTask(req = {}) {
	const requestOptions = {
		method: 'DELETE',
		headers: getHeaders(),
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(endpoints.CVAT_TASK_ASSIGN, requestOptions).then(handleResponse);
}

function completeTask(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: getHeaders(),
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(endpoints.CVAT_TASK_COMPLETE, requestOptions).then(
		handleResponse
	);
}

function fetchTaskAssignments(req = {}) {
	const url = toQueryStringURL(
		endpoints.CVAT_TASK_ASSIGNMENTS,
		req?.params ?? {}
	);
	const requestOptions = {
		method: 'GET',
		headers: getHeaders(),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function queueSelection(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: getHeaders(),
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(endpoints.CVAT_SELECTION, requestOptions).then(handleResponse);
}

function unqueueSelection(req = {}) {
	const requestOptions = {
		method: 'DELETE',
		headers: getHeaders(),
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(endpoints.CVAT_SELECTION, requestOptions).then(handleResponse);
}

function registerWebhook(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: getHeaders(),
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(endpoints.CVAT_WEBHOOK_REGISTER, requestOptions).then(
		handleResponse
	);
}

export default cvatServices;
